<app-error-page
    *ngIf="!loading && errors?.length > 0"
    [error]="errors"
></app-error-page>

<mat-progress-spinner
    *ngIf="loading"
    class="page-spinner"
    mode="indeterminate"
    diameter="40"
    strokeWidth="5"
    value="5"
></mat-progress-spinner>
<app-footer-v2
    *ngIf="
        !loading &&
        !!errors &&
        errors?.length > 0 &&
        errors[0]?.layoutType === '404-page'
    "
    [filter]="filter"
    [page]="'404'"
></app-footer-v2>
